<template>
	<div class="type-helper">
		<table>
			<tr>
				<td style="width:35px; vertical-align: top;">
					<v-icon>
						mdi-help-circle-outline
					</v-icon>
				</td>
				<td>
					Key Duty: Detail of specific duties and tasks completed in the position.<br />
					Deliverable: Specific deliverables and timeframes required of each key duty.<br />

					<a v-show="!showMore" href="#" @click="showMore = !showMore">See Example</a>
					<a v-show="showMore" href="#" @click="showMore = !showMore">Hide Example</a>
					<v-slide-y-transition>
						<div v-show="showMore">
							<v-data-table hide-actions :headers="headers" :items="examples" class="elevation-1 mt-3">
								<template v-slot:items="props">
									<td class="text-xs-left">{{ props.item.category }}</td>
									<td class="text-xs-left">{{ props.item.keyDuty }}</td>
									<td class="text-xs-left">{{ props.item.deliverables }}</td>
								</template>
							</v-data-table>
						</div>
					</v-slide-y-transition>
				</td>
			</tr>
		</table>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				showMore: false,
				headers: [
					{ text: 'Category', value: 'category' },
					{ text: 'Key Duty', value: 'keyDuty' },
					{ text: 'Deliverables', value: 'deliverables' }
				],
				examples: [
					{
						category: 'Admin',
						keyDuty: 'Coordinate mail in and out of business included travelling to post office',
						deliverables: 'Post office mail run completed daily by 10am'
					},
					{
						category: 'Admin',
						keyDuty: 'Coordinate stationary supplies with supplier',
						deliverables: 'Ensure stationary cupboard is fully stocked at all times'
					}
				]
			};
		}
	};
</script>

<style scoped>
	.type-helper {
		font-size: 14px;
		text-align: left;
		margin-bottom: 40px;
		margin-top: 10px;
		color: rgba(0, 0, 0, 0.54);
	}
</style>
